import { render, staticRenderFns } from "./ProjectDashboard.vue?vue&type=template&id=e4a8ed70"
import script from "./ProjectDashboard.vue?vue&type=script&lang=js"
export * from "./ProjectDashboard.vue?vue&type=script&lang=js"
import style0 from "./ProjectDashboard.vue?vue&type=style&index=0&id=e4a8ed70&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports